import useResponsive from "@/hooks/useResponsive";
import { Box, SxProps, styled, useTheme } from "@mui/material";
import { ReactNode, useRef } from "react";

/**
 * @param  leftChildren ReactNode
 * @param  leftChildrenSx SxProps
 * @param  rightChildren 可以为空
 * @param  rightChildrenSx SxProps
 * @param  ContentWrapSx SxProps
 * @param  showBorderBottom 是否显示左侧的底部边框
 * @param  id 内容区域 锚点ID
 * @returns
 */

export default function Index({
  leftChildren,
  leftChildrenSx,
  rightChildren = "",
  rightChildrenSx,
  ContentWrapSx,
  showBorderBottom = true,
  id,
  leftSticky = false,
  rightSticky = false,
}: {
  leftChildren: ReactNode;
  leftChildrenSx?: SxProps;
  rightChildren?: ReactNode;
  rightChildrenSx?: SxProps;
  ContentWrapSx?: SxProps;
  showBorderBottom?: boolean;
  id?: string;
  leftSticky?: boolean;
  rightSticky?: boolean;
}) {
  const isMobile = !useResponsive("up", "lg");
  const theme = useTheme();

  const leftRef = useRef<any>(null);
  const rightRef = useRef<any>(null);

  return (
    <ContentWrap
      sx={{ ...ContentWrapSx, flexDirection: isMobile ? "column" : "row" }}
      id={id}
    >
      <LeftBox
        ref={leftRef}
        sx={{
          width: isMobile ? "100%" : "60%",
        }}
      >
        <ContentWrapper
          sx={{
            borderBottom: showBorderBottom
              ? `1px dashed ${theme.palette.LightText.stroke}`
              : "none",
            ...leftChildrenSx,
          }}
        >
          {leftChildren}
        </ContentWrapper>
      </LeftBox>

      {(rightChildren || !isMobile) && (
        <DarkBox
          ref={rightRef}
          // className={`${!isLeftSticky && leftChildren ? "right-sticky" : ""}`}
          className={`${isMobile ? "intersection-dark-box" : "right-sticky"}`}
          sx={{
            ...rightChildrenSx,
            width: isMobile ? "100%" : "40%",
            // maxHeight: isMobile ? "800px" : "auto",
            // overflow: "auto",
          }}
        >
          <Box
            sx={{
              borderRadius: "16px",
              fontSize: "14px",
            }}
          >
            {rightChildren}
          </Box>
        </DarkBox>
      )}
    </ContentWrap>
  );
}

const ContentWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "stretch",
  // overflow: "hidden",
  // position: "relative",
  // zIndex: 999,

  ".left-sticky": {
    position: "sticky",
    top: "4px",
    maxHeight: "calc(100vh - 60px)",
    overflow: "auto",
  },
  ".right-sticky": {
    position: "sticky",
    top: "70px",
    maxHeight: "calc(100vh - 130px)",
    overflow: "auto",

    // backgroundColor: "red",
    "::-webkit-scrollbar": {
      display: "none",
      width: "6px",
      height: "6px",
    },

    "::-webkit-scrollbar-thumb": {
      borderRadius: "12px",
      backgroundColor: "#b6bcc1",
    },
  },
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  height: "100%",
  padding: "40px 0px",
  borderBottom: `1px dashed ${theme.palette.LightText.stroke}`,
}));

const LeftBox = styled(Box)(({ theme }) => ({
  padding: "0px 24px",
  overflow: "hidden",
  flexGrow: 1,
  width: "60%",
}));

const DarkBox = styled(Box)(({ theme }) => ({
  width: "40%",
  backgroundColor: theme.palette.grey[800],
  padding: "24px 16px",

  // maxHeight: "800px",
  // overflow: "auto",
}));
